import store from '../../store';

export default class AgentNotifyEvent {
  constructor(message) {
    const agentId = store.getters['attendance/attendance'].agentId;
    store.dispatch('notifications/loadNotifications', agentId);
  }
}
